<template>
  <div
    class="col-7 col-xl-2 col-lg-2 col-md-2 d-flex justify-content-end align-items-center d-lg-block d-xl-block d-xl-block job-info"
  >
    <span class="d-flex d-lg-none d-xl-none d-md-none price-per-hour">
      ${{ job.price_per_hour }}
    </span>
    <button
      v-if="canCreateClaim && !hasClaim"
      class="btn btn-primary create-claim-button"
      type="button"
      @click="$emit('createClaim', true)"
    >
      Create claim
    </button>
    <div
      class="float-right float-xl-right float-md-right float-lg-right order-2"
      v-if="job.status_id !== 40"
    >
      <div
        class="dropdown"
        v-if="
          $_can('jobs.status.update') ||
            $_can('jobs.carrier.assign') ||
            $_can('jobs.status.revert.accepted') ||
            $_can('jobs.status.revert.total_time')
        "
      >
        <button
          class="btn btn-secondary add-filter"
          type="button"
          id="dropdownMenuButton"
          :disabled="!hasAccess"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        />
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
          <template
            v-if="
              job.cash_collected !== null && $_can('jobs.set-cash-collected') && canShowCashCollect
            "
          >
            <button class="dropdown-item nav-link btn" @click="cashCollectModal = true">
              <template v-if="!job.cash_collected">
                Cash collect
              </template>
              <template v-else>
                Cash not collected
              </template>
            </button>
          </template>
          <template v-if="job.status_id === 16">
            <button
              class="dropdown-item nav-link btn"
              @click="$emit('showRevertToTotalTime')"
              v-if="$_can('jobs.status.revert.total_time')"
            >
              Revert to total time
            </button>
          </template>
          <template v-else>
            <template v-if="job.carrier === null || job.status_id === 31">
              <button
                class="dropdown-item nav-link btn"
                @click="$emit('showCarrierReassignModal', true)"
                v-if="$_can('jobs.carrier.assign')"
              >
                Assign carrier
              </button>
              <button
                class="dropdown-item nav-link btn"
                @click="$emit('showModalCancelJob', true)"
                v-if="job.status_id !== 30 && $_can('jobs.status.update')"
              >
                Cancel
              </button>
            </template>
            <template v-else>
              <template v-if="job.status_id === 1">
                <button
                  class="dropdown-item nav-link btn"
                  @click="$emit('showCarrierReassignModal', true)"
                  v-if="$_can('jobs.carrier.assign')"
                >
                  Assign carrier
                </button>
              </template>
              <template v-if="job.status_id === 2">
                <button
                  class="dropdown-item nav-link btn"
                  @click="$emit('showModalAcceptJob', true)"
                  v-if="job.status_id !== 31 && $_can('jobs.status.update')"
                >
                  Accept
                </button>
                <button
                  class="dropdown-item nav-link btn"
                  @click="$emit('showModalRejectJob', true)"
                  v-if="job.status_id !== 31 && $_can('jobs.status.update')"
                >
                  Reject
                </button>
                <button
                  class="dropdown-item nav-link btn"
                  @click="$emit('showCarrierReassignModal', true)"
                  v-if="$_can('jobs.carrier.assign')"
                >
                  Assign carrier
                </button>
                <button
                  class="dropdown-item nav-link btn"
                  @click="$emit('showModalCancelJob', true)"
                  v-if="job.status_id !== 30 && $_can('jobs.status.update')"
                >
                  Cancel
                </button>
              </template>
              <template v-if="job.status_id === 3">
                <button
                  class="dropdown-item nav-link btn"
                  v-if="$_can('jobs.status.update')"
                  @click="$emit('changeToInProgress')"
                >
                  In progress
                </button>
                <button
                  class="dropdown-item nav-link btn"
                  @click="$emit('showCarrierReassignModal', true)"
                  v-if="$_can('jobs.carrier.assign')"
                >
                  Assign carrier
                </button>
                <button
                  class="dropdown-item nav-link btn"
                  @click="$emit('showModalIsSmallJob', true)"
                >
                  Change job size
                </button>
                <button
                  class="dropdown-item nav-link btn"
                  @click="$emit('showModalCancelJob', true)"
                  v-if="job.status_id !== 30 && $_can('jobs.status.update')"
                >
                  Cancel
                </button>
              </template>
            </template>
            <button
              class="dropdown-item nav-link btn"
              @click="$emit('changeToOnHold')"
              v-if="
                (job.status_id === 1 ||
                  job.status_id === 2 ||
                  job.status_id === 3 ||
                  job.status_id === 31) &&
                  job.status_id !== 21 &&
                  $_can('jobs.status.update')
              "
            >
              On Hold
            </button>
            <button
              class="dropdown-item nav-link btn"
              @click="$emit('showRevertToAccepted')"
              v-if="canRevertToAccepted && $_can('jobs.status.revert.accepted')"
            >
              Revert to accepted
            </button>
            <button
              class="dropdown-item nav-link btn"
              @click="restoreStatus()"
              v-if="(job.status_id === 30 || job.status_id === 21) && $_can('jobs.status.update')"
            >
              Restore
            </button>
            <button
              class="dropdown-item nav-link btn"
              @click="$emit('reassignUserModal')"
              v-if="$_can('jobs.assign')"
            >
              Assign user
            </button>
            <button
              class="dropdown-item nav-link btn"
              @click="$emit('returnToPending')"
              v-if="job.status_id === 31 && $_can('jobs.status.update')"
            >
              Return To Pending
            </button>
            <button
              class="dropdown-item nav-link btn"
              @click="sendContractEmail"
              v-if="$_can('jobs.status.update') && !job.is_flat_rate"
            >
              Send pre-agreement
            </button>
            <button class="dropdown-item nav-link btn" @click="showModalRegistrationUrl = true">
              Send registration url
            </button>
            <button
              class="dropdown-item nav-link btn"
              @click="$emit('showSendEpayLink')"
              v-if="canSendEpayLink"
            >
              Send E-pay Link
            </button>
          </template>
        </div>
      </div>
    </div>
    <div
      class="float-right float-xl-right float-md-right float-lg-right order-2"
      v-if="job.status_id === 40"
    >
      <div class="dropdown" v-if="$_can('jobs.status.update') || $_can('jobs.carrier.assign')">
        <button
          class="btn btn-secondary add-filter"
          type="button"
          id="dropdownMenuButtonInProgress"
          :disabled="!hasAccess"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        />
        <div
          class="dropdown-menu dropdown-menu-right"
          aria-labelledby="dropdownMenuButtonInProgress"
        >
          <template>
            <button
              class="dropdown-item nav-link btn"
              @click="$emit('showRevertToAccepted')"
              v-if="canRevertToAccepted && $_can('jobs.status.revert.accepted')"
            >
              Revert to accepted
            </button>
            <button
              class="dropdown-item nav-link btn"
              @click="$emit('showModalCancelJob', true)"
              v-if="job.status_id !== 30 && $_can('jobs.status.update')"
            >
              Cancel
            </button>
          </template>
        </div>
      </div>
    </div>
    <button
      v-if="changes.length && job.status_id !== 16"
      class="btn btn-primary btn-changes float-lg-right"
      type="button"
      :disabled="!hasAccess"
      @click="loadJobChanges"
    >
      <span class="mod-icon-edit mod-icon-mailing" aria-hidden="true" />
    </button>
    <job-changes
      v-if="showModalChanges"
      :changes="changes"
      :model-id="job.id"
      :sending="job.company.send_automatic_emails"
      @close="showModalChanges = false"
      @ok="updateEmailSent"
    />
    <button
      v-if="showMovingContractButton"
      class="btn btn-danger btn-changes float-lg-right"
      type="button"
      @click="$emit('toggleEmailConfirmationModal')"
    >
      <span class="mod-icon-edit mod-icon-mailing" />
    </button>
    <send-email-confirmation
      v-if="showEmailConfirmationModal"
      :job-id="job.id"
      @sent="contractSent"
    />

    <!-- send booking link modal -->
    <modal
      v-if="showModalRegistrationUrl"
      @close="showModalRegistrationUrl = false"
      :size="'modal-large'"
      :close-strict="false"
    >
      <div slot="header">
        <div class="row">
          <div class="col-10">
            <div>
              <h4>Link to be sent</h4>
            </div>
          </div>
        </div>
      </div>
      <div slot="body">
        <div class="input-group">
          <input class="form-control" id="booking-link" type="text" :value="registerUrl" readonly />
          <div
            class="input-group-append pointer"
            @click.stop.prevent="copyToClipboard(registerUrl, 'Successfully copied to clipboard')"
          >
            <div class="input-group-text">
              <span>
                <i class="fa fa-copy list-box-icon" />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="d-flex align-items-center justify-content-end w-100" />
      </div>
    </modal>

    <!-- set cash collected modal -->
    <modal
      v-if="cashCollectModal"
      @close="cashCollectModal = false"
      :size="'modal-large'"
      :close-strict="false"
    >
      <div slot="header">
        <h4 v-if="!job.cash_collected">
          Cash collect
        </h4>
        <h4 v-else>
          Cash not collected
        </h4>
      </div>
      <div slot="body">
        <div class="text-center">
          <template v-if="!job.cash_collected">
            This will mark that the cash was collected for this job. Do you want to proceed?
          </template>
          <template v-else>
            This will mark that the cash was not collected for this job. Do you want to proceed?
          </template>
        </div>
        <div class="d-flex align-items-center justify-content-center mt-3" style="gap: 15px">
          <button class="btn btn-secondary" type="button" @click="cashCollectModal = false">
            No
          </button>
          <button type="button" class="btn btn-primary" @click="setCashCollected">Yes</button>
        </div>
      </div>
      <div slot="footer">
        <div class="d-flex align-items-center justify-content-end w-100" />
      </div>
    </modal>
  </div>
</template>
<script>
import axios from 'axios';
import toastr from 'toastr';
import JobChanges from './modals/JobChanges';
import Modal from '../Modal';
import SendEmailConfirmation from './modals/SendEmailConfirmation.vue';

export default {
  components: {
    JobChanges,
    Modal,
    SendEmailConfirmation,
  },
  props: {
    changes: {
      type: Array,
      default: () => [],
    },
    hasAccess: {
      type: Boolean,
      default: false,
    },
    showMovingContractButton: {
      type: Boolean,
      default: false,
    },
    job: {
      type: Object,
      default: () => {},
    },
    showEmailConfirmationModal: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showModalChanges: false,
    showModalRegistrationUrl: false,
    registerUrl: '',
    cashCollectModal: false,
  }),
  computed: {
    canRevertToAccepted() {
      return !(
        this.job.status_id === 1 ||
        this.job.status_id === 2 ||
        this.job.status_id === 3 ||
        this.job.status_id === 16 ||
        this.job.status_id === 31
      );
    },
    canCreateClaim() {
      return (
        this.job.status_id === 16 ||
        this.job.status_id === 30 ||
        this.job.status_id === 40 ||
        this.job.status_id === 41 ||
        this.job.status_id === 42
      );
    },
    canSendEpayLink() {
      return (
        (this.job.status_id === 41 || this.job.status_id === 42) &&
        this.$_can('jobs.elink.send') &&
        this.job.remaining_price > 0
      );
    },
    canShowCashCollect() {
      return (
        this.job.status_id === 16 ||
        this.job.status_id === 41 ||
        this.job.status_id === 42 ||
        this.job.status_id === 47
      );
    },
    hasClaim() {
      return this.job.claim !== null;
    },
  },
  mounted() {
    this.fetchRegisterUrl();
  },
  methods: {
    contractSent(immediate = true) {
      this.$emit('movingContractSent', immediate);
    },
    copyToClipboard(text, message) {
      this.$copyText(text).then(() => toastr.success(message, '', { timeOut: 1000 }));
    },
    fetchRegisterUrl() {
      axios.get(`/jobs/register-url/${this.job.id}`).then(res => {
        this.registerUrl = res.data.data.register_url;
      });
    },
    loadJobChanges() {
      this.showModalChanges = !this.showModalChanges;
      if (this.showModalChanges) {
        this.$emit('getChanges');
      }
    },
    setCashCollected() {
      axios.post(`/jobs/${this.job.id}/cash-collect`).then(() => {
        this.cashCollectModal = false;
        this.$emit('getJob');
      });
    },
    restoreStatus() {
      axios
        .patch(`jobs/${this.job.id}/restore-status`)
        .then(() => {
          this.$emit('getJob');
          toastr.success('Successfully restored job');
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    sendContractEmail() {
      axios
        .post(`jobs/${this.job.id}/mails/contract`)
        .then(() => {
          toastr.success('Successfully sent pre-agreement email');
          this.$emit('getJob');
        })
        .catch(err => {
          if (err.response.data.error.contract) {
            toastr.error(err.response.data.error.contract);
          } else {
            toastr.error(err.response.data.error);
          }
        });
    },
    updateEmailSent() {
      this.showModalChanges = false;
      this.$emit('getJob');
    },
  },
};
</script>
<style lang="scss" scoped>
.job-info {
  .price-per-hour {
    font-weight: bold;
    font-size: 18px;
    color: #4c5669;
    position: initial;
    margin-right: 5px;
  }
}
.dropdown-menu {
  max-height: 340px;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/JobInfo.vue